export default __webpack_public_path__ + "static/media/onboarding_irs_w9.82dc6607.png";